import axios from '@/components/api/axios';

async function getInvoiceNumber() {
  const res = await axios.axiosGet('/api/invoiceNumber/get', null);
  return res;
}

async function updateInvoiceNumber(invoiceNumber) {
  let data = {
    invoiceNumber: invoiceNumber
  }
  const res = await axios.axiosPost('/api/invoiceNumber/update', data);
  return res;
}

async function deleteInvoiceNumber() {
  // Postman と同様の空の JSON ボディ（リクエストボディなしに相当）
  const res = await axios.axiosPost('/api/invoiceNumber/delete', {});
  return res;
}

export default {
  getInvoiceNumber,
  updateInvoiceNumber,
  deleteInvoiceNumber
}



// WEBPACK FOOTER //
// ./src/components/api/invoice/invoice.js